<template>
  <ais-stats>
    <template slot-scope="{ nbHits }">
        <ais-query-rule-custom-data :transform-items="transformItems">
        <template slot="item" slot-scope="{ item }">
          <div class="banner-container">
            <a :href="item.link" class="">
              <img
                :src="item.promo_content"
                :alt="item.title"
                :style="{ width: '100%' }"
              />
            </a>
          </div>
        </template>
      </ais-query-rule-custom-data>
      <div v-if="nbHits > 0">
        <slot></slot>
      </div>
      <div
        class="no-results"
        v-else
      >
        <img src="@/assets/icons/no-results.png" />
        <p class="title">
          No results found
          <!--, <span class="query">{{ query }}</span> -->
        </p>
        <p class="message">
          We’ve searched over 6,000+ restaurants but we can’t seem to find what
          you’re looking for.
        </p>
      </div>
    </template>
  </ais-stats>
</template>

<script>
export default {
  data() {
    return {
      transformItems: items => {
        if (items.length > 0) {
          items.length = 1;
          return items.filter(item => Boolean(item.promo_content));
        }
      },

    };
  },
};
</script>

<style lang="scss" scoped>
.no-results {
  text-align: center;
}

.title {
  margin-bottom: 9px;
  font-size: 19px;
  font-weight: 800;
  color: $black;
}

.query {
  @include theme-value(color, brand-color-one);
}

.message {
  font-size: 15px;
  font-weight: 500;
  color: $black;
  line-height: 1.6;
}

img {
  width: 90px;
  margin: 17px 0;
}

.banner-container img {
    margin: 0;
}


.banner-container a {
    display: block;
    margin-bottom:30px;
}
</style>
